import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "submitted",
  "use": "submitted-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 13\" id=\"submitted\"><path d=\"M0 6.5C0 10.091 2.905 13 6.497 13A6.501 6.501 0 100 6.5zm1.3 0c0-2.873 2.327-5.2 5.2-5.2s5.2 2.327 5.2 5.2-2.327 5.2-5.2 5.2a5.199 5.199 0 01-5.2-5.2zm4.572 2.533c-.17 0-.33-.08-.43-.22l-1.1-1.48a.518.518 0 01.11-.74c.24-.18.57-.13.74.11l.67.91 2.18-2.93c.17-.24.5-.28.74-.11.24.18.29.51.11.74l-2.59 3.5c-.1.14-.26.22-.43.22z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol